export class MapTranslations {
  providersAtLocation?: string;

  constructor(obj: MapTranslations = {}) {
    this.providersAtLocation =
      obj.providersAtLocation || 'Providers at location';
  }
}
